import styled from 'styled-components';

const Row = styled.tr`
  height: 52px;
  vertical-align: middle;
`;

export default Row;
